import { configureStore } from '@reduxjs/toolkit'
import rootReducer from "../reducers";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { thunk } from "redux-thunk";

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['loading', 'toggleSidebar', 'tenant_admin', 'notification', 'networkRequests', 'sidebar']
}
const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: ()=> ([thunk]),
  devTools: process.env.NODE_ENV !== 'production'
})

export const persistor = persistStore(store)